<div class="container-fluid px-3" *ngIf="showMainContent">
    <app-list-roles />
  </div>
  <router-outlet></router-outlet>